<div class="title">
  <label>Route Config</label>
</div>
<div class="parent-route-title" *ngIf="hasParent">
  <label>Subroute of</label><label [innerText]="parentRoute"></label>
</div>
<div class="work-space">
  <form #routeForm="ngForm" (ngSubmit)="Submit()">
    <div class="form-group form-check" *ngIf="showVertexPrompt">
      <input [(ngModel)]="includeVertex" name="includeVertex" (ngModelChange)="Refresh()" type="checkbox">
      <label>Include selected point in new route?</label>
    </div>
    <div class="form-group form-check" *ngIf="showSegVertexPrompt">
      <input [(ngModel)]="includeSegVertex" name="includeSegVertex" (ngModelChange)="Refresh()" type="checkbox">
      <label>Add point to selected segment and include the point in new route?</label>
    </div>
    <div class="form-group">
      <label for="name">Route Name</label>
      <input [ngModel]="name" class="form-control" name="name" type="text" ngModel>
    </div>
  </form>
</div>
<div class="footer">
  <button class="btn btn-sm btn-primary" (click)="Submit()" type="button">Ok</button>
  <button class="btn btn-sm btn-primary" (click)="Hide()" type="button">Cancel</button>
</div>
